import { StoreState, useStore } from '~/store/store'

export const selectHasWriteAccess = (state: StoreState) => !state.user.read_only

export const useHasWriteAccess = () => useStore(selectHasWriteAccess)
